<template>
  <az-formbar>
    <div :class="inserindo?'hide':'show'">
      <div class="itens">
        <div class="item">
          <label>Número do Processo</label>
          <span>{{ licitacao.numProcesso }}</span>
          <br>
          <span v-if="licitacao.numRepeticao > 0">
                      <strong>Repetição: </strong>{{ licitacao.numRepeticao }}
                    </span>
        </div>
        <div class="item">
          <label>Situação</label>
          <span>{{ obterSituacaoLicitacao }}</span>
        </div>
        <div class="item">
          <label>Número do Edital</label>
          <span>{{ licitacao.numeroEdital }}</span>
        </div>
        <div class="item" v-show="licitacao.justificativa">
          <label>Justificativa</label>
          <span>{{ licitacao.justificativa }}</span>
        </div>
      </div>
      <div class="actions">
        <credenciamento-atualizacao-acoes-processo-digital v-if="podeAcessarProcessoVirtual"/>
        <credenciamento-atualizacao-acoes-documentos v-if="podeAcessarDocumentosVirtualizados"/>
        <credenciamento-atualizacao-acoes-publicar v-if="editando && !licitacao.publicado"/>
        <v-menu v-if="possuiRelatorioAnalise" class="relatorios-analise" offset-y left>
          <v-btn slot="activator" dark>
            Relatórios <v-icon>arrow_drop_down</v-icon>
          </v-btn>
          <v-list>
            <credenciamento-atualizacao-acoes-relatorio-analise
                v-for="(relatorio, index) in relatoriosAnalisesSolicitacoesCredenciamento"
                :key="index"
                :relatorio="relatorio">
            </credenciamento-atualizacao-acoes-relatorio-analise>
          </v-list>
        </v-menu>
        <div class="actions" v-if="editando">
          <v-menu v-model="menuAcoesAbertas" offset-y left>
            <v-btn slot="activator" dark icon>
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list>
              <credenciamento-atualizacao-acoes-excluir
                  v-if="exibirAcaoExcluir(licitacao)"
                  :licitacaoPublicada="licitacao.publicado"
                  @acao-ativada="fecharMenuAcoes"
              />
              <v-tooltip v-else-if="licitacao.publicado && licitacao.existeFornecedoresCredenciados" bottom>
                <template v-slot:activator="{ on }">
                  <v-list-tile v-on="on" disabled>
                    <v-list-tile-title>
                      <i class="fas fa-ban mr-2" aria-hidden="true" />
                      Despublicar
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
                <span>Não é possível despublicar pois existem participantes credenciados</span>
              </v-tooltip>

              <credenciamento-acoes-despublicar
                  v-else-if="licitacao.publicado && !licitacao.existeFornecedoresCredenciados"
                  :credenciamento-id="licitacao.id"
                  @acao-ativada="fecharMenuAcoes"
              />

              <v-list-tile v-else>
                <v-list-tile-title>Nenhuma ação disponível</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>
  </az-formbar>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {actionTypes} from '@/commons/constants'
import CredenciamentoAtualizacaoAcoesExcluir from './CredenciamentoAtualizacaoAcoesExcluir.vue'
import CredenciamentoAtualizacaoAcoesPublicar from './CredenciamentoAtualizacaoAcoesPublicar.vue'
import CredenciamentoAtualizacaoAcoesAcessar from './CredenciamentoAtualizacaoAcoesAcessar.vue'
import CredenciamentoAtualizacaoAcoesRefazer from './CredenciamentoAtualizacaoAcoesRefazer.vue'
import CredenciamentoAtualizacaoEnviarMaisBrasil from './CredenciamentoAtualizacaoEnviarMaisBrasil.vue'
import CredenciamentoAtualizacaoAcoesImprimirHistoricoMaisBrasil from './CredenciamentoAtualizacaoAcoesImprimirHistoricoMaisBrasil.vue'
import CredenciamentoAtualizacaoAcoesDocumentos from "@/views/credenciamento/detalhe-credenciamento/orgao/acoes/CredenciamentoAtualizacaoAcoesDocumentos.vue";
import CredenciamentoAtualizacaoAcoesProcessoDigital from "@/views/credenciamento/detalhe-credenciamento/orgao/acoes/CredenciamentoAtualizacaoAcoesProcessoDigital.vue";
import CredenciamentoAtualizacaoAcoesRelatorioAnalise from '@/views/credenciamento/detalhe-credenciamento/orgao/acoes/CredenciamentoAtualizacaoAcoesRelatorioAnalise.vue'
import CredenciamentoAcoesDespublicar from "@/views/credenciamento/detalhe-credenciamento/orgao/acoes/CredenciamentoAcoesDespublicar.vue";
import moment from "moment/moment";
export default {
  name: 'CredenciamentoAtualizacaoAcoes',
  components: {
    CredenciamentoAcoesDespublicar,
    CredenciamentoAtualizacaoAcoesRelatorioAnalise,
    CredenciamentoAtualizacaoAcoesProcessoDigital,
    CredenciamentoAtualizacaoEnviarMaisBrasil,
    CredenciamentoAtualizacaoAcoesAcessar,
    CredenciamentoAtualizacaoAcoesPublicar,
    CredenciamentoAtualizacaoAcoesExcluir,
    CredenciamentoAtualizacaoAcoesRefazer,
    CredenciamentoAtualizacaoAcoesImprimirHistoricoMaisBrasil,
    CredenciamentoAtualizacaoAcoesDocumentos
  },
  props: {
    inserindo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuAcoesAbertas: false,
      pollingTimer: null
    }
  },
  mounted() {
    if (this.ehCredenciamentoAguardandoAbertura) {
      this.pollingTimer = setInterval(() => {
        if (!this.ehCredenciamentoAguardandoAbertura) {
          this.buscarLicitacao(this.$route.params.id)
          clearInterval(this.pollingTimer)
          this.pollingTimer = null
        }
      }, 5000)
    }
  },
  beforeDestroy() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  },
  computed: {
    editando() {
      return this.$route.query.edicao
    },
    ehVirtualizacaoAtiva() {
      return this.parametros.propriedadesLicitacao.integration.virtualizacao.ativo
    },
    ehLicitacaoVirtualizada() {
      return !!this.licitacao.processoVirtualUrl
    },
    podeAcessarProcessoVirtual() {
      return this.ehVirtualizacaoAtiva && this.ehLicitacaoVirtualizada
    },
    podeAcessarDocumentosVirtualizados() {
      return this.ehVirtualizacaoAtiva && this.ehLicitacaoVirtualizada
    },
    possuiRelatorioAnalise() {
      return this.relatoriosAnalisesSolicitacoesCredenciamento.length > 0
    },
    obterSituacaoLicitacao() {
      if (this.licitacao.publicado) {
        if (this.ehCredenciamentoAguardandoAbertura) {
          return "Ag. Abertura"
        } else {
          return "Aberto"
        }
      } else {
        return "Em Elaboração"
      }
    },
    ehCredenciamentoAguardandoAbertura() {
      if (this.licitacao.publicado) {
        const dataAbertura = moment(this.licitacao.dataAbertura)
        const dataAtual = moment(new Date())

        return dataAtual.isBefore(dataAbertura)
      }
      return false;
    },
    ...mapState(['licitacao', 'parametros', 'relatoriosAnalisesSolicitacoesCredenciamento'])
  },
  methods: {
    ...mapActions({
      buscarLicitacao: actionTypes.BUSCAR_LICITACAO
    }),
    exibirAcaoExcluir(licitacao) {
      return !licitacao.publicado
    },
    fecharMenuAcoes() {
      this.menuAcoesAbertas = false
    }
  }
}
</script>

<style scoped lang="stylus">

  .item
    margin: 5px 10px 5px 10px

    label
      font-weight: bold

  .az-form-bar
    .show
      height auto !important

  .relatorios-analise .v-btn
    background-color #00568b !important
</style>
